import type { Color } from "./color";
import { rgbaToHsla } from "./color-conversions/rgba-to-hsla";
import { colorFactory } from "./color-factory";
import { hexColorByName } from "./color-names";
import type { HexColor } from "./hex-color/hex-color";
import { parseCssHex } from "./parce-css-hex";
import { parseCssHsla } from "./parse-css-hsla";
import { parseCssRgba } from "./parse-css-rgba";

const cssStringToColor = (cssColorString: string): Color => {
    const value = cssColorString.replace(/\s/g, "").toLowerCase();
    if (value.startsWith("rgb")) {
        const rgba = parseCssRgba(value);
        const hsla = rgbaToHsla(rgba);
        return colorFactory(hsla);
    }
    if (value.startsWith("#")) {
        const rgba = parseCssHex(value as HexColor);
        const hsla = rgbaToHsla(rgba);
        return colorFactory(hsla);
    }
    if (value.startsWith("hsl")) {
        const hsla = parseCssHsla(value);
        return colorFactory(hsla);
    }
    if (hexColorByName.has(value.toLowerCase())) {
        const hexValue = hexColorByName.get(value);
        if (!hexValue) throw new Error("Bad hex value: " + hexValue);
        const rgba = parseCssHex(hexValue);
        const hsla = rgbaToHsla(rgba);
        const color = colorFactory(hsla);
        return color;
    }

    throw new Error("Unknown css color string: " + cssColorString);
};

export { cssStringToColor };
